const uuidv4 = () => {
  const timestamp = +new Date();
  return timestamp;
};
export default uuidv4;
